/**
 * Social Media add-on tier pricing - display values mirror the Stripe Payment
 * Links configured in `backend/stripe_integration.SOCIAL_MEDIA_LINKS`.
 * Monthly subscriptions only.
 */

export const SOCIAL_MEDIA_TIERS = [
  {
    id: 'growth',
    label: 'Growth Plan',
    positioning: 'Consistent social media presence',
    price: { gbp: 429, eur: 499, usd: 549 },
    features: [
      'Up to 12 social media posts per month',
      'Management of up to 2 social platforms',
      'Static graphics and carousel content',
      'Caption and copywriting',
      'Legal-industry relevant content planning',
      'Hashtag and topic research',
      'Client approval workflow through the dashboard',
      'Scheduling and publishing after approval',
      'Profile optimisation',
      'Up to 1 revision round per post',
    ],
  },
  {
    id: 'authority',
    label: 'Authority Plan',
    positioning: 'Aggressive growth & content scale',
    featured: true,
    price: { gbp: 689, eur: 799, usd: 879 },
    features: [
      'Up to 20 social media posts per month',
      'Management of up to 3 social platforms',
      'Static graphics and carousel content',
      'Legal thought-leadership content',
      'Caption and copywriting',
      'Monthly content strategy and calendar',
      'Practice-area-specific content planning',
      'Client approval workflow through the dashboard',
      'Scheduling and publishing after approval',
      'Profile optimisation',
      'Competitor/content opportunity monitoring',
      'Up to 2 revision rounds per post',
      'Priority content requests',
    ],
  },
];

export const SM_CURRENCY_SYMBOL = { gbp: '£', eur: '€', usd: '$' };
